
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/przyczepy/lokalizacja/[lokalizacja]",
      function () {
        return require("private-next-pages/przyczepy/lokalizacja/[lokalizacja]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/przyczepy/lokalizacja/[lokalizacja]"])
      });
    }
  